import React from 'react';
import { useDispatch, useSelector } from "react-redux";
import Styles from "./Render.module.css";
import { toast } from "react-toastify";
import { AiOutlineDelete } from "react-icons/ai";
import {
    renderSettingsOptions,
    fpsNumAndDen,
    getResolutionFromHeightAndWidth,
    getfpsFromNumAndDen,
    getRenderStatus,
    getRenderTime,
} from "./render.constants";

import {
    requestRenderXVideo,
    deleteRenders,
    deleteAllRenders,
    downloadRender,
} from "../../../Redux/actions/projectActions";

const RendersTable = () => {

    const dispatch = useDispatch();

    let { isLoading, renders, _id: projectId, } = useSelector((state) => state?.project);

    const downLoadVideo = async (renderId) => {
        const urlRes = await dispatch(downloadRender(projectId, renderId));
        // console.log("urlRes", urlRes);
        if (urlRes?.success) {
            window.open(urlRes?.data?.downloadURL);
        } else {
            toast.error('URL Not Exist')
        }
    };

    const deleteRender = (renderId) => {
        const confirm = window.confirm(
            `Are you sure! You want to delete Render (${renderId})?`
        );
        if (confirm) dispatch(deleteRenders(projectId, renderId));
    };

    const clearHistory = async () => {
        const confirm = window.confirm(
            `Are you sure! You want to delete All Render ?`
        );
        if (confirm) {
            const res = await dispatch(deleteAllRenders(projectId));

            toast.success(res?.message)
        }
    };

    return (
        <div className='w-full h-full p-2'>
            <div className='flex items-center gap-5'>
                <div className=''>
                    <h3 className={Styles.rendHistory}>RENDER HISTORY</h3>
                </div>
                <div className='' style={{ textAlign: 'end' }}>
                    <button type='submit' className='mb-[0.9rem]' onClick={clearHistory} disabled={(renders?.length < 1)}
                        style={{ border: '2px solid #848484', borderRadius: '5px', color: '#fff', color: '#b3b3b7', fontSize: '12px', padding: ' 0 5px', transition: 'all .3s ease', cursor: 'pointer' }}>
                        Clear history
                    </button>
                </div>
            </div>

            <div className={Styles.historytabel}>
                <table className='' cellPadding="" width='100%'>
                    <thead>
                        <tr className='text-xl'>
                            <th className='pb-2'>Version</th>
                            <th className='pb-2'>Date</th>
                            <th className='pb-2'>Resolution</th>
                            <th className='pb-2'>Format</th>
                            <th className='pb-2'>FPS</th>
                            <th className='pb-2'>Aspect Ratio</th>
                            <th className='pb-2'>Time</th>
                            <th className='pb-2'>Status</th>
                            <th className='pb-2'>Download video</th>
                            <th className='pb-2'>Action</th>
                        </tr>

                        <tr style={{ border: '1px solid rgba(84, 96, 108, 1)', width: '100%' }}>
                            <div className=''></div>
                        </tr>
                    </thead>

                    <tbody className='text-lg'>
                        {renders?.map((render, idx) => (
                            render ? (
                                <tr className={Styles?.test11} key={idx}>
                                    <td >{idx + 1}</td>
                                    <td>
                                        {new Date(render?.createdAt).toDateString()} -{" "}
                                        {new Date(render?.createdAt).toTimeString()?.slice(0, 5)}
                                    </td>
                                    <td>
                                        {getResolutionFromHeightAndWidth(
                                            render?.videoHeight,
                                            render?.videoWidth
                                        )}
                                    </td>
                                    <td>{render?.format}</td>
                                    <td>
                                        {getfpsFromNumAndDen(
                                            render?.fpsNumerator,
                                            render?.fpsDenominator
                                        )}
                                    </td>
                                    <td>{render?.aspectRatio}</td>
                                    <td>{getRenderTime(render)}</td>
                                    <td>{getRenderStatus(render)}</td>
                                    <td>
                                        {render?.isVideoGenerated ? (
                                            <span
                                                className="cursor-pointer"
                                                style={{ color: '#f1a044' }}
                                                onClick={() => downLoadVideo(render._id)}
                                            >
                                                {render?.videoFilename ? render?.videoFilename : "Download"}
                                            </span>
                                        ) : (
                                            <span className="cursor-wait">-</span>
                                        )}
                                    </td>
                                    <td>
                                        <span
                                            className="cursor-pointer"
                                            onClick={() => deleteRender(render?._id)}
                                        >
                                            <AiOutlineDelete />
                                        </span>
                                    </td>
                                </tr>
                            ) : null

                        ))}
                    </tbody>
                </table>
            </div>
        </div>
    )
}

export default RendersTable;